import { DRAGONFRUIT_BLACK_01 } from '../colors/colors';

import { type Theme, ThemeVariables } from './theme';

export const DRAGONFRUIT_DARK_THEME: Theme = {
  [ThemeVariables.primaryBackgroundColor]: DRAGONFRUIT_BLACK_01,
};
